import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';

import { AppComponent } from '../../app.component';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class ResetPasswordService {

  constructor(private http:Http) { }

  reset(code:string, userId:string, password:string, confirmPassword:string){
     var data = {
       'code':code,
       'userId':userId,
       'password':password,
       'confirmPassword':confirmPassword
     };

     let headers = new Headers();
     headers.append('Content-Type', 'application/json');

     return this.http.post(AppComponent.DOMAIN + '/api/user/ResetPassword', data, {
        headers: headers
     }).map( response => response.json() );
  }
}



// WEBPACK FOOTER //
// ./src/app/login/reset-password/reset-password.service.ts